<span [zenTooltip]="toolTipText" [ngClass]="{
    'material-symbols-outlined': type !== this.iconConfig.FILL_ROUNDED && type !== this.iconConfig.OUTLINE_ROUNDED ,
    'material-symbols-rounded': type === this.iconConfig.FILL_ROUNDED || type === this.iconConfig.OUTLINE_ROUNDED ,
    'zsi-fill': type === this.iconConfig.FILL || type === this.iconConfig.FILL_ROUNDED,
    'zsi-outlined': type === this.iconConfig.OUTLINED || type === this.iconConfig.OUTLINE_ROUNDED 
  }">
  {{ iconName }}
</span>